import React from "react"
import {SvgIcon, SvgIconProps} from "@mui/material"

const exportIconSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="24" height="24">
            <path fill="currentColor" d="M7 17v4.5a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V17h1v4.5a1.5 1.5 0 0 1-1.5 1.5h-14A1.5 1.5 0 0 1 6 21.5V17zm8-11v11.293l3.146-3.146.707.707-4.353 4.353-4.353-4.353.707-.707L14 17.293V6z"></path>
        </svg>
)

const Export: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {exportIconSvg}
    </SvgIcon>
)

export default Export